/**
 *
 * @example <div ref={setRef(rootEl, fwdRef)}></div>
 *
*/
export default function (...refs) {
    return (instance) => {
        refs.forEach(ref => {
            if (typeof ref === 'function') {
                ref(instance);
            }
            else if (ref) {
                ref.current = instance;
            }
        });
    };
}
